<div class="layoutBlock">
	<div class="columnThreeQuarter">
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	
		<res-publication-edit-abstract
            [hisDynamicContent]="'fs.res.publication.Publication.textAbstract'" [dynamicComponent]="publication._dynamicComponent"
			[publication]="publication">
		</res-publication-edit-abstract>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	</div>
</div>
